import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { logout } from '~/auth/slices/auth.slice'

interface MindOverlayState {
  showMindDetailsOverlay: boolean
}

const initialState: MindOverlayState = {
  showMindDetailsOverlay: false,
}

const slice = createSlice({
  name: 'mindOverlay',
  initialState,
  reducers: {
    setShowMindDetailsOverlay: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showMindDetailsOverlay: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
  },
})

export const selectShowMindDetailsOverlay = (state: RootState): boolean => state.mindOverlay.showMindDetailsOverlay

export const { setShowMindDetailsOverlay: setShowMindDetailsOverlayActionCreator } = slice.actions

export default slice.reducer
